/**
 * UrgentBadge + FlagIcon — small reusable visual flag for activity_log
 * entries (D-106) carrying `is_urgent=1`. Mirrors the visual vocabulary of
 * the task is_critical flag so the user's eye reads urgency the same way
 * across surfaces (Notes Client Updates tab, Overview headlines block,
 * eventually the client portal).
 *
 * Two sizes:
 *   - <UrgentBadge /> — pill with "URGENT" label, used in the modal header
 *     status line and as a row badge where horizontal space allows.
 *   - <UrgentDot /> — flag icon only, no text, for compact row layouts.
 */

export function UrgentBadge() {
  return (
    <span
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded border text-[11px] font-semibold"
      style={{
        background: 'var(--color-danger-soft)',
        borderColor: 'var(--color-danger)',
        color: 'var(--color-danger)',
      }}
      title="Flagged urgent"
    >
      <FlagIcon filled />
      <span>URGENT</span>
    </span>
  );
}

export function UrgentDot({ title = 'Flagged urgent' }: { title?: string }) {
  return (
    <span
      className="inline-flex items-center justify-center w-4 h-4 rounded"
      style={{
        background: 'var(--color-danger-soft)',
        color: 'var(--color-danger)',
      }}
      title={title}
      aria-label={title}
    >
      <FlagIcon filled />
    </span>
  );
}

export function FlagIcon({ filled }: { filled: boolean }) {
  return (
    <svg
      viewBox="0 0 16 16"
      width={11}
      height={11}
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M3 14V2.5h7l-1 2.25 1 2.25H3" />
      <line x1="3" y1="14" x2="3" y2="9" />
    </svg>
  );
}
